import { render, staticRenderFns } from "./DifferenceNumber.vue?vue&type=template&id=853da8ae&"
import script from "./DifferenceNumber.vue?vue&type=script&lang=js&"
export * from "./DifferenceNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports